/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const dealflowPitchDeckDtoSchema = z.object({
  name: z.optional(z.string()),
  description: z.optional(z.string()),
});
